import { InlineGrid, Page } from "@shopify/polaris";
import React from "react";
import ImmediateActions from "./subcomponents/ImmediateActions";
import ManageAdditionalCountries from "./subcomponents/ManageAdditionalCountries";
import MustRead from "./subcomponents/MustRead";

const AdditionalCountries = () => {
  return (
    // <Page>
    <div style={{ padding: "10px 30px" }}>
      {/* <div style={{ marginBottom: "18px" }}>
        <ImmediateActions />
      </div> */}
      <InlineGrid gap="400" columns={["oneHalf", "oneHalf"]}>
        <MustRead />
        <ManageAdditionalCountries />
      </InlineGrid>
    </div>

    // </Page>
  );
};

export default AdditionalCountries;
